export default __webpack_public_path__ + "static/media/toggle.554c24b5.svg";